import styled from 'styled-components';
import { Form } from 'antd';

const MainContainer = styled.div`
  .section-hero--notification {
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: var(--green-5);
    max-width: 370px;
    margin: 1em auto 0;
  }
`;

const ProgressiveFormContainer = styled(Form)`
  display: flex;

  .ant-row.ant-form-item:first-child {
    width: 100%;
    max-width: 314px;
  }

  .text-field-wrapper {
    .text-field-input {
      height: 62px !important;
      box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
    }
  }

  button {
    font-weight: bold;
    padding: 15px 24px;
    min-width: 184px;
    margin-left: 16px;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

    &:hover {
      box-shadow: none;
    }

    &:disabled {
      background-color: var(--neutral-2) !important;
      color: var(--disabled-text-color);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .ant-row.ant-form-item {
      width: 100%;
      margin-bottom: 12px;

      &:first-child {
        max-width: 100%;
      }
    }

    .text-field-wrapper .text-field-input {
      height: 55px !important;
    }

    button {
      font-size: 18px;
      line-height: 31px;
      padding: 12px 24px;
      width: 100%;
      margin-left: 0;
    }
  }
`;

export { MainContainer, ProgressiveFormContainer };
